import React from 'react';
import ItemsList from '../ItemsList';
export default React.memo(ItemsList);